import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/index.css'
import App from './App.tsx'
import { initMonitoring } from './lib/monitoring.ts'
import { initTelemetryCollector } from './lib/telemetryCollector.ts'
import { initChunkReloadGuard } from './lib/chunkReload.ts'
import { bootMark } from './lib/boot/bootTrace.ts'
import { clearBootPlaceholder, hideNativeSplash } from './lib/boot/splash.ts'
import { applyFrameScrollMode, installStatusTapToTop } from './lib/layout/frameScrollMode.ts'

bootMark('main', 'start')

// Antes do render: a primeira pintura já nasce com o scroller certo (BUG-300).
if (applyFrameScrollMode()) installStatusTapToTop()

initChunkReloadGuard()
initMonitoring()
initTelemetryCollector()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

bootMark('main', 'ok', 'render disparado')

/**
 * A troca de camadas só acontece DEPOIS que o React pintou.
 *
 * `render()` é assíncrono no React 18 — remover o placeholder na linha seguinte
 * descobriria uma tela vazia por um ou dois frames, que é exatamente o flash que
 * este placeholder existe para evitar. Dois `requestAnimationFrame` seguidos
 * põem o trabalho depois do primeiro commit pintado.
 */
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    clearBootPlaceholder()
    void hideNativeSplash()
  })
})
